import {dateFormat, timeFormat} from "../utils/DateFormat";
import moment from "moment";

export const eventDateToUtcTimestamp = currentStart => {
    const date = dateFormat(currentStart);
    const time = timeFormat(currentStart);
    return moment(`${date} ${time}`, "YYYY-M-D H:m:s").utc().valueOf();
};
